<template>
  <div class="client document-preview d-inline-block">
    <div
      :block="block"
      :color="color"
      :flat="flat"
      :icon="icon"
      @click="open = true"
      class="ma-0"
      :class="[link ? color : '', { hoverable : link }]"
      :small="small"
      :is="link ? 'a' : 'v-btn'"
    >
      <v-icon :left="!icon" v-if="prependIcon">mdi-paperclip</v-icon>
      <span v-if="label && !icon">{{ label }}</span>
      <span v-else-if="!icon">{{ title }}</span>
      <v-icon :right="!icon" v-if="appendIcon">mdi-paperclip</v-icon>
    </div>
    <v-dialog v-if="file" v-model="open" lazy>
      <v-layout column>
        <v-flex d-flex xs12>
          <v-toolbar>
            <v-toolbar-title>{{ title }} Preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon  @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
        </v-flex>
        <v-card>
          <v-container fluid grid-list-xs>
            <v-layout row wrap fill-height>
              <v-flex d-flex>
                <v-img
                  v-if="isImage"
                  :height="`${height}px`"
                  :style="`background: center no-repeat url('${file.url}'); background-size: contain;`"
                />
                <v-img v-else>
                  <iframe :src="file.url" :height="height" width="100%" style="border: 0;"></iframe>
                </v-img>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    appendIcon: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    color: { type: String },
    file: { type: [Object, File] },
    flat: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    label: { type: String, default: '' },
    link: { type: Boolean, default: false },
    prependIcon: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    isImage() {
      if (typeof this.file === 'object') {
        return /^image\//.test(this.file.content)
      } else {
        return false
      }
    },
    height() {
      return this.$vuetify.breakpoint.height * 0.7
    },
  },
}
</script>

<style>
.client.document-preview .hoverable:hover {
  text-decoration: underline;
}
</style>
